import Danger from 'src/assets/img/menu/expiry_status/danger.png'
import Warning from 'src/assets/img/menu/expiry_status/warning.png'
import Safe from 'src/assets/img/menu/expiry_status/safe.png'

export default class Item {
  constructor(
    id,
    name,
    image,
    description,
    expiredAt,
    itemKind,
    rarity,
    increaseLove,
    type,
    amount
  ) {
    this.id = id
    this.name = name
    this.description = description
    this.image = image
    this.expiredAt = expiredAt
    this.itemKind = itemKind
    this.rarity = rarity
    this.increaseLove = increaseLove
    this.type = type
    this.amount = amount
  }
}

export const ITEM_RARITY = {
  R: 'r',
  SR: 'sr',
  SSR: 'ssr'
}

export const RARITY_POINTS = {
  r: 5,
  sr: 20,
  ssr: 100
}

export const ITEM_TYPE = {
  Standard: 'SettingItem',
  Special: 'SpecialItem',
  Payment: 'PaymentItem'
}

export const EXPIRY_STATUS = {
  red: Danger,
  yellow: Warning,
  blue: Safe
}
